import { useState, useEffect, useRef } from 'react';
import { GetRequest } from 'components/common';

// The hot stamping materials the owner offers on the carton material the visitor chose, and the dieline's parts that
// can be hot stamped, fetched again on every material change. null until the chosen material's answer arrives (a late
// answer for a material the visitor has left is dropped); none when the fetch fails, so the form simply offers no hot
// stamping.
const useHotStampingChoices = (widgetIdentifier, cartonMaterialUserPriceId, drawingId) => {
  const [hotStamping, setHotStamping] = useState(null);
  const requestedKeyRef = useRef(null);

  const fetchHotStamping = () => {
    const requestedKey = `${cartonMaterialUserPriceId}_${drawingId}`;
    requestedKeyRef.current = requestedKey;
    setHotStamping(null);
    if (!widgetIdentifier || !cartonMaterialUserPriceId || !drawingId) {
      return;
    }
    GetRequest({
      url: `/widget/quote-builder/${widgetIdentifier}/hot-stamping?carton_material_user_price_id=${cartonMaterialUserPriceId}&drawing_id=${drawingId}`,
      callback: (data) => {
        if (requestedKeyRef.current !== requestedKey) { return; }
        setHotStamping({ hotStampingMaterials: data.hot_stamping_materials, parts: data.parts });
      },
      onError: () => {
        if (requestedKeyRef.current !== requestedKey) { return; }
        setHotStamping({ hotStampingMaterials: [], parts: [] });
      }
    });
  };

  useEffect(fetchHotStamping, [widgetIdentifier, cartonMaterialUserPriceId, drawingId]);

  return hotStamping;
};

export default useHotStampingChoices;
